import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daterange'
})
export class FiltersPipe implements PipeTransform {

  transform(value: any, daterange: any[]): any {
    if (!value) return null;
    if (daterange.length == 0) return value;


    let start = new Date(daterange[0]);
    let end = new Date(daterange[1]);

    // start.setDate(start.getDate() - 1);
    // end.setDate(end.getDate() + 1);

    return value.filter((item: any) => {
      let date = new Date(item.invoiceDate);
      return date >= start && date <= end;
    });



  }

}
